import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'

import server from 'server/serverController2'
import { removeItem, formatDate, getBase64FromUrl } from 'utils/utils'
import { sendWebViewMsg } from 'utils/bridge'
import constants from 'utils/constants'

import TaskResultFormModal from 'components/containers/task/modal/TaskResultFormModal'
import TaskReportModal from 'components/containers/task/modal/TaskReportModal'

import UserReportModal from 'components/containers/report/UserReportModal'

//presenters
import FeedList from 'components/presenters/feed/detail/FeedList'
import BottomModal from 'components/presenters/modal/BottomModal'
import CenterModal from 'components/presenters/modal/CenterModal'
//lottieFile
import likeAnimation from 'images/lottiefile/like_animation_red.json'
//commentModal
import TaskDetail from 'components/containers/task/TaskDetail'
import SocialShareModal from 'components/containers/share/SocialShareModal'

const MainFeed = ({ params, type, onDelete, onEdit }) => {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })

  const [feedList, setFeedList] = useState([])
  const [feedsLastNumber, setFeedsLastNumber] = useState(null)
  const [commentsLastNumber, setCommentsLastNumber] = useState(null)
  const [currentFeedNo, setCurrentFeedNo] = useState(null)
  const [currFeed, setCurrFeed] = useState(null)
  const [clickTimeout, setClickTimeout] = useState(null)
  //CommentState
  const [commentList, setCommentList] = useState([])
  const [commentVisible, setCommentVisible] = useState(false)
  const [isCommentLoading, setIsCommentLoading] = useState(false)
  const [isCommentLoadEnd, setIsCommentLoadEnd] = useState(false)
  const [insertedCommentList, setInsertedCommentList] = useState([])
  const [isCommentSlideOn, setIsCommentSlideOn] = useState(true)

  const taskDetailVisible = useRef(commentVisible)
  //LoadingState
  const [isLoading, setIsLoading] = useState(false)
  const [isEnd, setIsEnd] = useState(false)
  //LikeAnimationState
  const [isLikeAnimation, setIsLikeAnimation] = useState(false)
  //BottomModalState
  const [bottomModalVisible, setBottomModalVisible] = useState(false)
  const [bottomModalDataList, setBottomModalDataList] = useState([])
  //CenterModalState
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)
  //BottomFormState
  const [bottomFormVisible, setBottomFormVisible] = useState(false)
  const [rows, setRows] = useState(1)
  //feedFescription
  // const [feedDescLimit, setFeedDescLimit] = useState(26)
  const [showMoreFeedNoList, setShowMoreFeedNoList] = useState([])
  const feedDescLimit = 26
  const history = useHistory()
  //TaskReportModal
  const [reportModalVisible, setReportModalVisible] = useState(false)
  const [reportTargetNo, setReportTargetNo] = useState(null)
  //UserReportModal
  const [userReportModalVisible, setUserReportModalVisible] = useState(false)
  const [userReportTargetNo, setUserReportTargetNo] = useState(null)
  //TaskResultFormModal
  const [showTaskResultForm, setShowTaskResultForm] = useState(false)
  const [targetTaskNo, setTargetTaskNo] = useState(null)
  //ReportUserNo
  const [reportedUserNo, setReportedUserNo] = useState([])
  //SocialShareModal
  const [socialShareModalVisible, setSocialShareModalVisible] = useState(false)
  const [shareTaskNo, setShareTaskNo] = useState(null)
  const [shareImg, setShareImg] = useState(null)
  const [initSocialShareModal, setInitSocialShareModal] = useState(false)

  let isDeletingTaskResult = false

  //type에 따른 url
  let url = null
  if (type === 'campaign') {
    url = `campaigns/${params['id']}/feed`
  } else if (type === 'company') {
    url = `users/feed/company`
  } else if (type === 'group') {
    url = `groups/${params['id']}/feed`
  } else if (type === 'archive') {
    url = `users/${userInfo['id']}/archive`
  } else {
    url = 'users/feed'
  }
  const initCallBack = (feedsData) => {
    try {
      if (feedsData['success'] !== 1) {
        return
      }

      const feed = type === 'archive' ? feedsData.data.archive : feedsData.data.feed
      if (feed.length > 0) {
        setIsEnd(false)
        setFeedsLastNumber(feed[feed.length - 1]['no'])
      } else {
        setIsEnd(true)
      }
      const showMoreNoList = []
      for (let i = 0; i < feed.length; ++i) {
        const newFeedItem = checkMoreBtnRequired(feed[i])
        if (newFeedItem['is_show_desc'] === true) {
          showMoreNoList.push(newFeedItem['no'])
        }
      }
      setShowMoreFeedNoList(showMoreNoList)
      setFeedList(feed)
    } catch (err) {
      console.log(err)
    }
  }

  const checkMoreBtnRequired = (feedItem) => {
    if (!feedItem['description']) {
      feedItem['is_show_desc'] = true
    } else {
      const feedDescriptions = feedItem['description'].split('\n')
      if (feedDescriptions[0].length > feedDescLimit) {
        feedItem['is_show_desc'] = false
      } else if (feedDescriptions.length > 1) {
        feedItem['is_show_desc'] = false
      } else {
        feedItem['is_show_desc'] = true
      }
    }
    return feedItem
  }
  const deleteFeedRequest = async (currTaskNo) => {
    if (isDeletingTaskResult === false) {
      isDeletingTaskResult = true
      const res = await server.deleteRequestData(`tasks/${currTaskNo}/result`)
      isDeletingTaskResult = false
      if (res?.success === 0) {
        setCenterModalVisible(true)
        const errData = res?.error?.res_data
        if (errData?.detail_code === 'PAYBACK_ALREADY_PROCESSED') {
          setCenterModalDataList({
            description: `환급챌린지 인증사진은\n 삭제가 불가능합니다.\n 관리자에게 문의해주세요.`,
          })
        } else {
          setCenterModalDataList({
            description: `투두리스트 삭제에 실패했어요.\n 나중에 다시 시도해주세요.`,
          })
        }
        setOnModalCancel(null)
        setOnModalComplete(() => () => setCenterModalVisible(false))

        return
      }
      const { deleted_item } = res.data
      handleDeleteTaskTrigger(deleted_item[0])
      setCenterModalVisible(false)
      if (onDelete) {
        onDelete(deleted_item[0]['task_no'])
      }
    }
  }

  const addLikeRequest = async (currTask) => {
    try {
      if (userInfo['isLogin'] === false) {
        handleEmptyUserInfo()
        return
      }
      const resultData = await server.postRequestData(`tasks/${currTask['task_no']}/like`)
      if (resultData['success'] === 0) {
        return
      }
      setIsLikeAnimation(true)
      const { inserted_item } = resultData.data
      onTriggerCreateLike(inserted_item['task_no'])
      setCurrentFeedNo(currTask['task_no'])
      setTimeout(() => {
        setIsLikeAnimation(false)
      }, 1500)
    } catch (error) {
      console.log(error)
    }
  }

  const deleteLikeRequest = async (currfeed) => {
    try {
      const resultData = await server.deleteRequestData(`tasks/${currfeed['task_no']}/like`)
      if (resultData['success'] === 0) {
        return
      }
      const { deleted_item } = resultData.data
      onTriggerDeleteLike(deleted_item[0]['task_no'])
    } catch (error) {
      console.log(error)
    }
  }

  const onTriggerUpdateTask = (currFeedNo, proof, description) => {
    const feeds = [...feedList]
    feeds.map((feedItem) => {
      if (feedItem['task_no'] === currFeedNo) {
        feedItem['proof'] = proof
        feedItem['description'] = description
        feedItem['is_show_desc'] = true
        setShowMoreFeedNoList([...showMoreFeedNoList, feedItem['no']])
      }
    })

    setFeedList(feeds)
  }

  const onTriggerCreateComment = (currFeedNo) => {
    const feeds = [...feedList]
    feeds.map((feedItem) => {
      if (feedItem['task_no'] === currFeedNo) {
        feedItem['total_comment'] =
          feedItem['total_comment'] !== null ? parseInt(feedItem['total_comment']) + 1 : 1
      }
    })
    setFeedList(feeds)
  }

  const onTriggerDeleteComment = (currFeedNo) => {
    const feeds = [...feedList]
    feeds.map((feedItem) => {
      if (feedItem['task_no'] === currFeedNo) {
        feedItem['total_comment'] = parseInt(feedItem['total_comment']) - 1
      }
    })
    setFeedList(feeds)
  }

  const onTriggerCreateLike = (currFeedNo) => {
    const feeds = [...feedList]
    feeds.map((feedItem) => {
      if (feedItem['task_no'] === currFeedNo) {
        feedItem['total_like'] = parseInt(feedItem['total_like']) + 1
        feedItem['liked_task'] = true
      }
    })
    setFeedList(feeds)
  }

  const onTriggerDeleteLike = (currFeedNo) => {
    const feeds = [...feedList]
    feeds.map((feedItem) => {
      if (feedItem['task_no'] === currFeedNo) {
        feedItem['total_like'] = parseInt(feedItem['total_like']) - 1
        feedItem['liked_task'] = false
      }
    })
    setFeedList(feeds)
  }

  const handleOpenCommentModal = (currentFeed) => {
    if (userInfo['isLogin'] === false) {
      handleEmptyUserInfo()
      return
    }
    setCurrFeed(currentFeed)
    setCommentVisible(true)
    setIsCommentSlideOn(true)
  }

  const handleOpenReportModal = (currentFeed) => {
    if (userInfo['isLogin'] === false) {
      handleEmptyUserInfo()
      return
    }
    setReportTargetNo(currentFeed['task_no'])
    setReportModalVisible(true)
    setBottomModalVisible(false)
  }

  const handleOpenUserReportModal = (currentFeed) => {
    if (userInfo['isLogin'] === false) {
      handleEmptyUserInfo()
      return
    }

    setUserReportTargetNo(currentFeed['user_no'])
    setUserReportModalVisible(true)
    setBottomModalVisible(false)
  }

  const handleSocialShare = async (currentFeed) => {
    try {
      const feedImages = currentFeed.proof.map((image) => {
        return `${constants.imagePath}/task_img/${image}`
      })

      const dataUrl = await getBase64FromUrl(feedImages[0])

      if (currentFeed['share_req']) {
        setSocialShareModalVisible(true)
        setShareTaskNo(currentFeed['task_no'])
        setShareImg(dataUrl)
        setBottomModalVisible(false)
        return
      }

      const res = await sendWebViewMsg({
        action: 'REQ_INSTAGRAM_SHARE',
        data: {
          share_options: {
            url: dataUrl,
            type: 'image/*',
          },
        },
      }).catch((err) => {
        console.log('err from msg')
        console.log(err)
      })

      if (res.success !== 1) {
        return
      }
      setBottomModalVisible(false)
    } catch (error) {
      console.log('error')
      console.log(error)
    }
  }

  const handleBottomModalState = (currentFeed) => {
    let optionMenu = []
    if (userInfo['role'] === 'admin' || userInfo['id'] === currentFeed['user_no']) {
      // optionMenu.push({
      //   type: 'callback',
      //   text: '공유하기',
      //   callback: () => handleSocialShare(currentFeed),
      //   style: { color: '#000000' },
      // })
      if (currentFeed['task_date'] >= formatDate()) {
        // optionMenu.push({
        // 	type: "callback",
        // 	text: "게시물 수정",
        // 	callback: handleEditTask,
        // 	callbackParam: currentFeed,
        // 	style: { color: "#000000" },
        // })
      }
      optionMenu.push({
        type: 'callback',
        text: '게시물 삭제',
        callback: handleCenterModalState,
        callbackParam: currentFeed,
        style: { color: '#DE0000' },
      })
    }
    if (userInfo['id'] !== currentFeed['user_no']) {
      optionMenu.push({
        type: 'callback',
        text: '인증샷 신고',
        callback: () => handleOpenReportModal(currentFeed),
        style: { color: '#DE0000' },
      })
      optionMenu.push({
        type: 'callback',
        text: '유저 신고',
        callback: () => handleOpenUserReportModal(currentFeed),
        style: { color: '#DE0000' },
      })
    }

    setBottomModalDataList(optionMenu)
    setBottomModalVisible(true)
  }

  const handleEditTask = (param) => {
    setShowTaskResultForm(true)
    setTargetTaskNo(param['task_no'])
    setBottomModalVisible(false)
  }
  const handleCenterModalState = (param) => {
    setCenterModalDataList({
      type: 'callback',
      title: '게시물 삭제',
      description: '게시물을 삭제하시겠어요?\n적립된 포인트와\n스티커도 함께 사라져요.',
    })
    setOnModalComplete(() => () => {
      deleteFeedRequest(param['task_no'])
      setCommentVisible(false)
    })
    setOnModalCancel(() => () => setCenterModalVisible(false))
    setCenterModalVisible(true)
    setBottomModalVisible(false)
  }

  const handleEmptyUserInfo = () => {
    setCenterModalDataList({ type: 'callback', description: '로그인이 필요해요' })
    setOnModalComplete(() => () => history.replace('/social'))
    setOnModalCancel(() => () => setCenterModalVisible(false))
    setCenterModalVisible(true)
  }

  const handleDoubleClick = (currTask) => {
    if (clickTimeout !== null) {
      clearTimeout(clickTimeout)
      if (currTask['liked_task'] === false) {
        setCurrentFeedNo(currTask['task_no'])
        addLikeRequest(currTask)
        setClickTimeout(null)
        return
      }
    } else {
      setClickTimeout(
        setTimeout(() => {
          clearTimeout(clickTimeout)
          setClickTimeout(null)
        }, 500),
      )
    }
  }

  const handleFeedScroll = (e) => {
    if (
      !isEnd &&
      !isLoading &&
      e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight
    ) {
      setIsLoading(true)
      server.getRequestData(`${url}?last_pos_no=${feedsLastNumber}`, (res) => {
        if (res['success'] !== 1) {
          setIsEnd(true)
          setIsLoading(false)
          return
        }

        const feeds = type === 'archive' ? res.data.archive : res.data.feed
        if (feeds.length === 0) {
          setIsEnd(true)
          setIsLoading(false)
          return
        }
        setFeedsLastNumber(feeds[feeds.length - 1]['no'])
        setFeedList([...feedList, ...feeds])
        setIsLoading(false)
      })
    }
    setBottomFormVisible(false)
  }

  const loadNextComments = (currentFeed) => {
    if (!isCommentLoading && !isCommentLoadEnd) {
      setBottomFormVisible(false)
      setIsCommentLoading(true)
      server.getRequestData(
        `tasks/${currentFeed['task_no']}/comments?last_pos_no=${commentsLastNumber}&limit=5`,
        (res) => {
          if (res['success'] === 0 || res.data.comments.length === 0) {
            setIsCommentLoading(false)
            setIsCommentLoadEnd(true)
            return
          }
          const { comments } = res.data
          setCommentsLastNumber(comments.length === 0 ? 0 : comments[comments.length - 1].no)
          setCommentList((list) => {
            return list.concat(comments)
          })
          setIsCommentLoading(false)
        },
      )
    }
  }

  const handleClickMore = (index) => {
    const feeds = feedList
    if (feeds[index]['is_show_desc']) {
      return
    }
    feeds[index]['is_show_desc'] = true
    setShowMoreFeedNoList([...showMoreFeedNoList, feeds[index]['no']])
    setFeedList(feeds)
  }

  const handleDeleteTaskTrigger = (targetTask) => {
    const feeds = [...feedList]
    let index = 0
    for (let i = 0; i < feeds.length; ++i) {
      if (feeds[i]['task_no'] === targetTask['task_no']) {
        index = i
      }
    }
    const reloadFeeds = removeItem(feeds, index)
    setFeedList(reloadFeeds)
  }

  const hideUserFeed = (targetUser) => {
    setReportedUserNo([...reportedUserNo, targetUser.no])
  }

  const handleReportComplete = () => {
    setCenterModalVisible(true)
    setCenterModalDataList({
      type: 'callback',
      title: '인증샷 신고 완료',
      description:
        '신고접수가 완료되었어요.\n모티너스 운영팀에서 검토 후,\n삭제/미인증 처리하겠습니다.',
    })
    setOnModalComplete(() => () => {
      setCenterModalDataList({})
      setOnModalComplete(null)
      setCenterModalVisible(false)
    })
  }

  const handleUserReportComplete = () => {
    setCenterModalVisible(true)
    setCenterModalDataList({
      type: 'callback',
      title: '유저 신고 완료',
      description:
        '신고접수가 완료되었어요.\n모티너스 운영팀에서 검토 후,\n후속 조치 취하도록 하겠습니다.',
    })
    setOnModalComplete(() => () => {
      setCenterModalDataList({})
      setOnModalComplete(null)
      setCenterModalVisible(false)
    })
  }

  useEffect(() => {
    let queryString = null
    if (['campaign', 'group'].includes(type)) {
      //if post No Exist
      //modify url
      const lastPosNo = parseInt(params['post'])
      queryString = `last_pos_no=${lastPosNo + 1}`
    } else if (['archive'].includes(type)) {
      const lastPosNo = parseInt(params['taskNo'])
      queryString = `last_pos_no=${lastPosNo + 1}`
    }
    if (type !== 'normal' && type !== 'company') {
      server.getRequestData(`${url}?${queryString}`, initCallBack)
    }
    if (type === 'company' || type === 'normal') {
      server.getRequestData(`${url}`, initCallBack)
    }
  }, [type])

  useEffect(() => {
    if (initSocialShareModal) {
      setSocialShareModalVisible(false)
      setShareImg(null)
      setInitSocialShareModal(false)
    }
  }, [initSocialShareModal])

  const lottieOptions = {
    loop: false,
    autoplay: true,
    renderer: 'svg',
    animationData: likeAnimation,
  }

  return (
    <>
      <FeedList
        feedList={feedList}
        userInfo={userInfo}
        addLikeRequest={addLikeRequest}
        deleteLikeRequest={deleteLikeRequest}
        handleBottomModalState={handleBottomModalState}
        commentVisible={commentVisible}
        commentList={commentList}
        currentFeedNo={currentFeedNo}
        handleFeedScroll={handleFeedScroll}
        loadNextComments={loadNextComments}
        handleDoubleClick={handleDoubleClick}
        isLikeAnimation={isLikeAnimation}
        insertedCommentList={insertedCommentList}
        type={type}
        lottieOptions={lottieOptions}
        onClickComment={handleOpenCommentModal}
        feedDescLimit={feedDescLimit}
        handleClickMore={handleClickMore}
        showMoreFeedNoList={showMoreFeedNoList}
        reportedUserNo={reportedUserNo}
      />
      <TaskResultFormModal
        visible={showTaskResultForm}
        taskNo={targetTaskNo}
        onSubmit={(response) => {
          const targetTask = response['data']
          const targetProof = response['data']['proof']

          const newFeedList = feedList.slice()
          for (let i = 0; i < newFeedList.length; ++i) {
            if (targetTask['task_no'] === newFeedList[i]['task_no']) {
              newFeedList[i]['proof'] = targetProof
              newFeedList[i]['description'] = targetTask['description']
            }
          }
          setFeedList(newFeedList)
          setShowTaskResultForm(false)
          setTargetTaskNo(null)
          if (onEdit) {
            onEdit(targetTask)
          }
        }}
        onClose={() => {
          setShowTaskResultForm(false)
          setTargetTaskNo(null)
        }}
      />
      <BottomModal
        visible={bottomModalVisible}
        setVisible={setBottomModalVisible}
        dataList={bottomModalDataList}
      />
      <CenterModal
        modalVisible={centerModalVisible}
        setModalVisible={setCenterModalVisible}
        dataList={centerModalDataList}
        onCancel={onModalCancel}
        onComplete={onModalComplete}
      />
      {reportModalVisible && reportTargetNo ? (
        <TaskReportModal
          visible={reportModalVisible}
          setVisible={setReportModalVisible}
          reportTargetNo={reportTargetNo}
          setReportTargetNo={setReportTargetNo}
          onDeleteTaskTrigger={handleDeleteTaskTrigger}
          onReportComplete={handleReportComplete}
        />
      ) : null}
      {commentVisible && currFeed ? (
        <TaskDetail
          currTaskNo={currFeed['task_no']}
          addLikeRequest={addLikeRequest}
          deleteLikeRequest={deleteLikeRequest}
          currentFeedNo={currentFeedNo}
          handleDoubleClick={handleDoubleClick}
          isLikeAnimation={isLikeAnimation}
          lottieOptions={lottieOptions}
          setCommentVisible={setCommentVisible}
          handleBottomModalState={handleBottomModalState}
          animation={true}
          isCommentSlideOn={isCommentSlideOn}
          setIsCommentSlideOn={setIsCommentSlideOn}
          deleteFeedRequest={deleteFeedRequest}
          onTriggerCreateComment={onTriggerCreateComment}
          onTriggerDeleteComment={onTriggerDeleteComment}
          onTriggerCreateLike={onTriggerCreateLike}
          onTriggerDeleteLike={onTriggerDeleteLike}
          onTriggerUpdateTask={onTriggerUpdateTask}
          handleOpenReportModal={handleOpenReportModal}
          onDeleteTaskTrigger={handleDeleteTaskTrigger}
          loadNextComments={loadNextComments}
          onUserReportComplete={handleUserReportComplete}
          hideUserFeed={hideUserFeed}
        />
      ) : null}
      <UserReportModal
        userReportModalVisible={userReportModalVisible}
        setUserReportModalVisible={setUserReportModalVisible}
        userReportTargetNo={userReportTargetNo}
        setUserReportTargetNo={setUserReportTargetNo}
        onUserReportComplete={handleUserReportComplete}
        hideUserFeed={hideUserFeed}
      />
      <SocialShareModal
        visible={socialShareModalVisible}
        shareImg={shareImg}
        taskNo={shareTaskNo}
        onClose={() => {
          setInitSocialShareModal(true)
        }}
        onShare={() => {
          setInitSocialShareModal(true)
        }}
      />
    </>
  )
}

export default MainFeed
